module.exports = __webpack_public_path__ + "img/card_feature_4_grand_cherokee.5b5a4cc6.jpg";